import { Root, createRoot } from 'react-dom/client';

const roots = new WeakMap<Element, Root>();

export const initializeRoot = (element: Element) => {
  const result = createRoot(element);
  roots.set(element, result);
  return result;
};

export const ensureRoot = (element: Element) =>
  roots.get(element) ?? initializeRoot(element);

export const disposeRoot = (element: Element) => {
  roots.get(element)?.unmount();
  roots.delete(element);
};
